import Vue from 'vue';
import arrays from './arrays';

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
});

Vue.filter('formatHora', function (value) {
  if (value) {
    return moment(value, 'DD/MM/YYYY H:mm').format('H:mm')
  }
});

Vue.filter('fromNow', function (value) {
  if (value) {
    return moment(String(value)).fromNow()
  }
});

Vue.filter('formatDateHora', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY H:mm')
  }
});

Vue.filter('calcIdade', function (value) {
  var birthday = +new Date(value);
  return ~~((Date.now() - birthday) / (31557600000));
});

Vue.filter('toUpper', function (value) {
  if (!value) return ''
  return value.toUpperCase();
});


Vue.filter('clearText', function (value) {
  if (!value) return ''
  return value.normalize("NFD")
    .replace(/([\u0300-\u036f])/g, "")
    .replace(/([^\w]+|\s+)/g, "-")
    .replace(/\-+/g, " ")
    .toUpperCase();
});

Vue.filter('maskNumber', function (value) {
  if (!value) return 0
  return typeof value === "string" || typeof value === "number"
    ? value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    : "";
});

Vue.filter('formatDateYMD', function (value) {
  if (value) {
    return moment(
      value,
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
  }
});

Vue.filter('moedaRS', function (value) {
  if (!value) return ''
  return value.toLocaleString('pt-br', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' });
});

Vue.filter('moeda', function (value) {
  if (!value) return ''
  return value.toLocaleString('pt-br', { minimumFractionDigits: 2 });
});

Vue.filter('limit', function (value, leng, dots = '') {
  if (!value) return ''
  return value.substring(0, leng) + ' ' + dots;
});

Vue.filter('highlight', function (words = null, query = null, query_secondary = null, class_secondary = null) {
  if (!words) return ''
  var iQuery = new RegExp(query, "ig");
  var iQuery_secondary = new RegExp(query_secondary, "ig");

  if (query_secondary) {
    words = words.toString().replace(iQuery_secondary, function (matchedTxt, a, b) {
      return (`<span class="${class_secondary}">` + matchedTxt + '</span>');
    });
  }
  if (query) {
    words = words.toString().replace(iQuery, function (matchedTxt, a, b) {
      return ('<span class=\'highlightText\'>' + matchedTxt + '</span>');
    });
  }

  return words;

});


Vue.filter('formatEscolaridade', (value) => {
  if (!value) return "";

  try {
    return arrays.tiposEscolaridadeTecnicos.filter(
      (elem) => {
        if (elem.id == value) {
          return elem.value;
        }
      }
    )[0]['value'];
  } catch (error) {
    console.error(error);
    return "Não encontrado";
  }

})


Vue.filter('formatCargaHoraria', (value) => {
  if (!value) return "";

  try {
    return arrays.cargaHorariaTecnicos.filter(
      (elem) => {
        if (elem.id == value) {
          return elem.value;
        }
      }
    )[0]['value'];
  } catch (error) {
    console.error(error);
    return "Não encontrado";
  }

})

Vue.filter('formatRegimeTrabalhoTecnicos', (value) => {
  if (!value) return "";

  try {
    return arrays.regimeTrabalhoTecnicos.filter(
      (elem) => {
        if (elem.id == value) {
          return elem.value;
        }
      }
    )[0]['value'];
  } catch (error) {
    console.error(error);
    return "Não encontrado";
  }

})

Vue.filter('getMotivoAcolhimentoCriancas', (value) => {
  if (!value) return "";

  try {
    return arrays.acolhimento_motivo.filter(
      (elem) => {
        if (elem.id == value) {
          return elem.value;
        }
      }
    )[0]['value'];
  } catch (error) {
    console.error(error);
    return "Não encontrado";
  }

})


Vue.filter('getMotivoAcolhimentoIdosos', (value) => {
  if (!value) return "";

  try {
    return arrays.acolhimento_motivo_idoso.filter(
      (elem) => {
        if (elem.id == value) {
          return elem.value;
        }
      }
    )[0]['value'];
  } catch (error) {
    console.error(error);
    return "Não encontrado";
  }

})

Vue.filter('formatSituacaoPrioritaria', (value) => {
  if (!value) return "";
  var array = JSON.parse(value);

  var situacoes = [
    { id: 1, value: 'Não está em situação prioritária' },
    { id: 2, value: 'Em situação de isolamento' },
    { id: 3, value: 'Trabalho infantil' },
    { id: 4, value: 'Vivência de violência e/ou negligência' },
    { id: 5, value: 'Fora da escola ou com defasagem escolar superior a 2 (dois) anos' },
    { id: 6, value: 'Em situação de acolhimento' },
    { id: 7, value: 'Em cumprimento de medida socioeducativa em meio aberto' },
    { id: 8, value: 'Egressos de medidas socioeducativas' },
    { id: 9, value: 'Situação de abuso e/ou exploração sexual' },
    { id: 10, value: 'Com medidas de proteção do ECA' },
    { id: 11, value: 'Crianças e adolescentes em situação de rua' },
    { id: 12, value: 'Vulnerabilidade que diz respeito às pessoas com deficiência' },
    { id: 13, value: 'Outras' }
  ];

  var stringValues = "";

  // Iterar sobre o array de IDs
  for (var i = 0; i < array.length; i++) {
    var id = array[i];
    // Procurar o objeto correspondente ao ID
    var objeto = situacoes.find(function (item) {
      return item.id === id;
    });
    // Se encontrarmos o objeto, adicionar o value à string separada por vírgula
    if (objeto) {
      stringValues += objeto.value;
      // Adicionar vírgula se não for o último valor
      if (i < array.length - 1) {
        stringValues += ', ';
      }
    }
  }

  return stringValues;

})
